import React from "react";
import Barra from "../components/Barra";
import PanelEnsombrado from "../components/PanelEnsombrado";

export default function Ensombrado() {
  return (
    <div className="app-shell">
      <Barra titulo="Ensombrado" />
      <PanelEnsombrado />
    </div>
  );
}
